import {isDate} from './typeValidate'
/*
* 日期格式化
*
* param {Date}      value  -传入的Date对象
* type  {String}    type   -将要被格式化的类型
* */

const formDate = (value, type = 'yy-mm-dd', zh = false) => {
    if (!isDate(value)) {
        console.error('value必须为Date类型');
        return value;
    }
    let Y = value.getFullYear();
    let M = value.getMonth() + 1;
    let D = value.getDate();
    if (M < 10) {
        M = '0' + M;
    }
    if (D < 10) {
        D = '0' + D;
    }
    if (type === 'yy-mm-dd') {
        if(zh){
            return '' + Y + '年' + M + '月' + D + '日';
        }
        return '' + Y + '-' + M + '-' + D;
    } else if (type === 'yymmdd') {
        return '' + Y + M + D;
    } else if (type === 'yy-mm') {
        return '' + Y + '-' + M;
    } else if (type === 'yymm') {
        return '' + Y + M;
    }
};
const formYearMonth = (value, type = 'yy-mm', zh = false) => {
    if (!isDate(value)) {
        console.error('value必须为Date类型');
        return value;
    }
    let Y = value.getFullYear();
    let M = value.getMonth() + 1;
    let D = value.getDate();
    if (M < 10) {
        M = '0' + M;
    }
    if (D < 10) {
        D = '0' + D;
    }
    if (type === 'yy-mm-dd') {
        if(zh){
            return '' + Y + '年' + M + '月' + D + '日';
        }
        return '' + Y + '-' + M + '-' + D;
    } else if (type === 'yymmdd') {
        return '' + Y + M + D;
    } else if (type === 'yy-mm') {
        return '' + Y + '-' + M;
    } else if (type === 'yymm') {
        return '' + Y + M;
    }
};
// 获取范围日期
// 默认获取一年内，开始日期为今天，
const dateScope = (number = 1, date = new Date(), type = 'Y') => {
    if (type === 'Y') {
        date.setFullYear(date.getFullYear() - number);
    } else if (type === 'M') {
        date.setMonth(date.getMonth() - number);
    }
    return date;
};
// 日期选择器设置
const datePickerOptions = () => {
    return {
        shortcuts: [
            {
                text: '今天',
                value() {
                    return new Date();
                }
            },
            {
                text: '一个月前',
                value() {
                    let date = new Date();
                    date.setMonth(date.getMonth() - 1)
                    return date;
                }
            },
            {
                text: '三个月前',
                value() {
                    let date = new Date();
                    date.setMonth(date.getMonth() - 3);
                    return date;
                }
            },
            {
                text: '六个月前',
                value() {
                    let date = new Date();
                    date.setMonth(date.getMonth() - 6);
                    return date;
                }
            },
            {
                text: '一年前',
                value() {
                    let date = new Date();
                    date.setFullYear(date.getFullYear() - 1);
                    return date;
                }
            }
        ]
    }
};
export {
    formDate,
    dateScope,
    datePickerOptions,
    formYearMonth
}



// WEBPACK FOOTER //
// ./src/static/js/utils/modules/formDate.js